// extracted by mini-css-extract-plugin
export var option = "_b5-0";
export var optionCard = "_b5-f";
export var optionContent = "_b5-g";
export var optionIcon = "_b5-i";
export var optionIconBox = "_b5-h";
export var optionLabel = "_b5-j";
export var optionPill = "_b5-m";
export var optionPillBadge = "_b5-p";
export var optionPillIcon = "_b5-n";
export var optionPillLabel = "_b5-o";
export var optionRadio = "_b5-k";
export var optionRadioInner = "_b5-l";
export var optionReveal = "_b5-2";
export var optionRevealDelay0 = "_b5-3";
export var optionRevealDelay1 = "_b5-4";
export var optionRevealDelay10 = "_b5-d";
export var optionRevealDelay11 = "_b5-e";
export var optionRevealDelay2 = "_b5-5";
export var optionRevealDelay3 = "_b5-6";
export var optionRevealDelay4 = "_b5-7";
export var optionRevealDelay5 = "_b5-8";
export var optionRevealDelay6 = "_b5-9";
export var optionRevealDelay7 = "_b5-a";
export var optionRevealDelay8 = "_b5-b";
export var optionRevealDelay9 = "_b5-c";
export var optionSelected = "_b5-1";